import UISideNav from 'UIComponents/nav/UISideNav';
import { UIRouterSideNavContextProvider } from 'UIComponents/nav/UISideNavItem';
import { SideNav } from 'foundations-components/transitional/components/SideNav';
import { cloneDefaultProps, clonePropTypes, isLegacyComponent } from './internal/utils';

/**
 * A [`SideNav`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-sidenav--basic)
 * type component with router support.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIRouterSideNav(props) {
  // TODO remove this logic after deprecating style & className props
  if (isLegacyComponent(props, ['style', 'className'])) {
    return /*#__PURE__*/_jsx(UISideNav, Object.assign({}, props));
  } else {
    return /*#__PURE__*/_jsx(UIRouterSideNavContextProvider, {
      value: {
        useTrellisComponents: true
      },
      children: /*#__PURE__*/_jsx(SideNav, Object.assign({}, props))
    });
  }
}

// TODO remove after deprecating UIComponents part
UIRouterSideNav.propTypes = Object.assign({}, clonePropTypes(UISideNav));

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIRouterSideNav.defaultProps = cloneDefaultProps(UISideNav);